import { Localization } from "./localization";

// todo: extract the week-of-year calculations etc into a calender-type object, so it can be replaced for different calender types.

export const weekStartsAtIndex = 1; // 0 = sunday

export interface DayModel {
    date: Date;
}

export interface WeekModel {
    firstDate: Date;
    days: DayModel[];
}

export interface MonthModel {
    firstDate: Date;
    weekOfFirstDate: number;
    daysInMonth: number;
}

export function buildHalfYear(date: Date) {
    const year = date.getFullYear();
    const firstMonth = Math.floor(date.getMonth() / 6) * 6;
    return [
        buildMonthModel(year, firstMonth),
        buildMonthModel(year, firstMonth + 1),
        buildMonthModel(year, firstMonth + 2),
        buildMonthModel(year, firstMonth + 3),
        buildMonthModel(year, firstMonth + 4),
        buildMonthModel(year, firstMonth + 5)
    ];
}


export function buildMonthModel(year: number, monthIndex: number): MonthModel {
    const date = new Date(year, monthIndex);
    return {
        firstDate: date,
        weekOfFirstDate: getWeek(date),
        daysInMonth: new Date(year, monthIndex + 1, 0).getDate()
    };
}

export function getWeek(date: Date) {
    const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    // Set to nearest Thursday (this is the key to ISO week calculation)
    // Thursday is day 4, so we add (4 - dayOfWeek) days
    const dayOfWeek = (targetDate.getDay() + 6) % 7; // Monday = 0, Sunday = 6
    const nearestThursday = new Date(targetDate);
    nearestThursday.setDate(targetDate.getDate() + 4 - dayOfWeek);

    // Get January 1st of the Thursday's year
    const yearOfThursday = nearestThursday.getFullYear();
    const jan1 = new Date(yearOfThursday, 0, 1);

    // Calculate week number
    const week = Math.ceil(((nearestThursday.getTime() - jan1.getTime()) / 86400000 + 1) / 7);
    return week;
}

export function buildWeekModel(date: Date, count = 7): WeekModel {
    const firstDayInWeek = getMondayOfWeek(date);
    return {
        firstDate: firstDayInWeek,
        days: range(count).map(offset => {
            const newDate = new Date(firstDayInWeek.valueOf());
            newDate.setDate(newDate.getDate() + offset);
            return {
                date: newDate
            };
        })
    }
}

function getMondayOfWeek(date: Date): Date {
    const monday = new Date(date);
    const day = monday.getDay();
    const offset = (day === 0 ? 6 : day - 1);
    monday.setDate(monday.getDate() - offset);
    return monday;
}

export function range(count: number) {
    return Array.from(Array(count).keys());
}

export const weekdayLetters = ["S", "M", "T", "W", "T", "F", "S"]
export const dayNames = [Localization.sunday, Localization.monday, Localization.tuesday, Localization.wednesday, Localization.thursday, Localization.friday, Localization.saturday];
export const monthNames = [Localization.january, Localization.february, Localization.march, Localization.april, Localization.may, Localization.june, Localization.july, Localization.august, Localization.september, Localization.october, Localization.november, Localization.december];

